<template>
  <div class="message-info">
    <div class="title">系统公告</div>
    <div class="content">
      <template v-if="context && context.length">
        <div v-for="(msg, index) in context" :key="msg.id" class="msg-item" @click="showFullMessage(msg)">
          {{ index + 1 }}、{{ msg.title }}：{{ msg.content }}
        </div>
      </template>
      <template v-else>
        <div class="no-data">
          暂无数据
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { loadSystemMssage } from '../services'
export default {
  name: 'DayOrderInfo',
  data () {
    return {
      loading: true,
      context: []
    }
  },
  methods: {
    loadData () {
      this.loading = true
      loadSystemMssage().then((resp) => {
        this.context = resp
      }).finally(() => {
        this.loading = false
      })
    },
    showFullMessage (msg) {
      this.$msgbox({
        title: msg.title,
        message: msg.content,
        confirmButtonText: '确定',
        showCancelButton: false
      })
    }
  },
  beforeMount () {
    this.loadData()
  }
}
</script>
